<ng-container *ngIf="!!video">
  <ng-container *ngIf="!!video.videoPlayer">
    <flo-video-player
      [video]="video.videoPlayer.contentMetadata"
      isAutoPlayed="true"
    ></flo-video-player>
  </ng-container>

  <h2 class="headline font-family-bold mt-2">{{ video.title }}</h2>
  <p class="subhead color-500">{{ video.subtitle }}</p>

  <div *ngIf="!!video.description" class="content full-content">
    <div class="description" data-test="video-description" floDynamicContent>
      <p [innerHtml]="video.description | floSanitizeHtml"></p>
    </div>
  </div>
  
  <ng-container *ngIf="video.tags">
    <div class="d-flex flex-wrap gap-2">
      <span class="subhead color-500">Tags: </span>
      <span *ngFor="let tag of video.tags; trackBy: trackById">
        <flo-link [link]="tag"></flo-link>
      </span>
    </div>
  </ng-container>
</ng-container>
